import React, { useState, useEffect } from "react";
import { Button } from "../common/Button";
import * as api from "../../api/user-app-api.js";

export const OrderHistoryScreen = ({ setView }) => {
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const userId = localStorage.getItem("userId");

    useEffect(() => {
        const loadOrders = async () => {
            if (!userId) {
                console.error("❌ No user ID found in localStorage");
                setIsLoading(false);
                return;
            }

            try {
                console.log("==>", userId);
                const res = await api.fetchUserOrders({ user_id: userId });
                console.log("📦 Orders API Response:", res.data);

                if (res.data.status === "success" && Array.isArray(res.data.data)) {
                    setOrders(res.data.data);
                } else {
                    setOrders([]);
                }
            } catch (error) {
                console.error("Error loading orders:", error);
                setOrders([]);
            } finally {
                setIsLoading(false);
            }
        };

        loadOrders();
    }, []);

    const formatDate = (dateStr) => {
        if (!dateStr) return "Unknown date";
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-IN", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "pending":
                return "text-yellow-600 bg-yellow-100";
            case "scheduled":
                return "text-blue-600 bg-blue-100";
            case "picked up":
                return "text-[#01a499] bg-[#01a499]/10";
            case "cancelled":
                return "text-red-600 bg-red-100";
            default:
                return "text-gray-600 bg-gray-100";
        }
    };

    if (isLoading) {
        return <div className="p-4">Loading orders...</div>;
    }

    return (
        <div className="p-4 pt-0 mb-16">
            {orders.length === 0 ? (
                <div className="text-center py-8">
                    <p className="text-gray-600 mb-4">
                        You haven’t placed any orders yet.
                    </p>
                    <Button onClick={() => setView("cart")}>Start Selling Scrap</Button>
                </div>
            ) : (
                <div className="space-y-4">
                    {orders.map((order) => (
                        <div>
                            <div
                                key={order.id}
                                onClick={() => setView("orderDetail", { orderId: order.id })}
                                className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 space-y-2 cursor-pointer relative"
                            >
                                <div className="flex justify-between items-start">
                                    <div>
                                        <p className="font-semibold text-gray-900">
                                            Order #{String(order.id).padStart(6, "0")}
                                        </p>
                                        <p className="text-sm text-gray-600">
                                            Order Placed Date: {formatDate(order.created_at)}
                                        </p>
                                        {order.status == 'Scheduled' ? (
                                            <p className="text-sm text-orange-600">
                                                Pick up Scheduled: {formatDate(order.estimated_date)}
                                            </p>
                                        ) : null}
                                    </div>
                                    <span
                                        className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(
                                            order.status
                                        )}`}
                                    >
                                        {order.status || "Pending"}
                                    </span>
                                </div>
                                {order.status == 'Picked Up' && (
                                    <div>
                                        {order.order_type == 'SELL' ? (
                                            <p className="text-sm text-gray-600">
                                                Total Value: ₹{order.total_estimated_value || 0}
                                            </p>) : (
                                            <p className="text-sm text-[#01a499]">
                                                DONATION
                                            </p>
                                        )}
                                    </div>
                                )}
                                {order.status == 'Pending' && (
                                    <div>
                                        <p className="text-sm text-[#01a499] text-xs font-medium mb-1">
                                            Your Pickup Request Received.
                                        </p>
                                        <p className="text-sm text-yellow-600 text-xs">
                                            Note: Our executive will contact you for scheduling the pickup. Please keep your phone available.
                                        </p>
                                    </div>
                                )}
                            </div>
                            {order.status == 'Scheduled' && (
                                <div className="text-center bg-[#01a499] p-1 pt-5 rounded-xl mt-[-15px] ">
                                    <p className="text-sm text-center text-white text-xs">
                                        Your Pickup Request Received.
                                    </p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
